import {
  queryApplicationList,
  createApplication,
  updateApplication,
} from '@/services/systemApplication';

export default {
  namespace: 'systemApplication',

  state: {
    data: {
      list: [],
      pagination: {},
    },
    result: {},
  },

  effects: {
    *fetch({ payload }, { call, put }) {
      const { data } = yield call(queryApplicationList, payload);
      yield put({
        type: 'save',
        payload: {
          list: data.data,
          pagination: {
            total: data.total,
            pageSize: data.per_page,
            current: data.current_page,
          },
        },
      });
    },

    *create({ payload }, { call }) {
      const { status, data } = yield call(createApplication, payload);
      if (!/20\d/.test(status)) {
        return false;
      }
      return data;
    },

    *update({ payload }, { call }) {
      const { status, data } = yield call(updateApplication, payload);
      if (!/20\d/.test(status)) {
        return false;
      }
      return data;
    },
  },

  reducers: {
    save(state, action) {
      return {
        ...state,
        data: action.payload,
      };
    },
  },
};
